import { useState } from "react"
import * as S from "./styled"
import { formatMoney } from "../../utils/tb/formatMoney"

type Props = {
  /** Código já aplicado (null = nenhum). */
  appliedCode: string | null
  discountTotal: number
  loading: boolean
  error: string
  disabled?: boolean
  onApply: (code: string) => void
  onRemove: () => void
  onClearError: () => void
}

const CouponField = ({
  appliedCode,
  discountTotal,
  loading,
  error,
  disabled = false,
  onApply,
  onRemove,
  onClearError,
}: Props) => {
  const [code, setCode] = useState("")

  const submit = () => {
    const clean = code.trim()
    if (clean && !loading && !disabled) onApply(clean)
  }

  return (
    <S.Wrapper>
      <S.Title>Cupom de desconto</S.Title>

      {appliedCode ? (
        <S.Applied>
          <span>
            Cupom <strong>{appliedCode}</strong> aplicado
            {discountTotal > 0 ? ` (- ${formatMoney(discountTotal, true)})` : ""}
          </span>
          <button
            type="button"
            onClick={() => {
              setCode("")
              onRemove()
            }}
            disabled={loading || disabled}
          >
            Remover
          </button>
        </S.Applied>
      ) : (
        <>
          <S.Row>
            <S.Input
              value={code}
              placeholder="Digite o código"
              aria-label="Cupom de desconto"
              autoCapitalize="characters"
              autoComplete="off"
              maxLength={30}
              $error={!!error}
              onChange={(e) => {
                setCode(e.target.value.replace(/[^a-zA-Z0-9_-]/g, ""))
                if (error) onClearError()
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault()
                  submit()
                }
              }}
            />
            <S.Button
              type="button"
              onClick={submit}
              disabled={!code.trim() || loading || disabled}
            >
              {loading ? "Aplicando..." : "Aplicar"}
            </S.Button>
          </S.Row>
          {error && (
            <S.Error role="alert" aria-live="polite">
              {error}
            </S.Error>
          )}
        </>
      )}
    </S.Wrapper>
  )
}

export default CouponField
